var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { styled } from '../theme/ThemeHelpers';
import { getColor } from '../helpers/ColorHelpers';
var Polaroid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    min-width: 150px;\n    background: ", ";\n    box-shadow: ", ";\n    margin-bottom: 15px;\n    margin: 0 ", " 15px ", ";\n    float: ", ";\n"], ["\n    width: ", ";\n    min-width: 150px;\n    background: ", ";\n    box-shadow: ", ";\n    margin-bottom: 15px;\n    margin: 0 ", " 15px ", ";\n    float: ", ";\n"])), function (props) { var _a; return (_a = props.width) !== null && _a !== void 0 ? _a : "100%"; }, function (props) { return getColor(props, props.theme.colors.mainBackground); }, function (props) { return props.shadowed ? props.theme.appStart.boxShadow : "none"; }, function (props) { return props.floated === "left" ? "15px" : 0; }, function (props) { return props.floated === "right" ? "15px" : 0; }, function (props) { var _a; return (_a = props.floated) !== null && _a !== void 0 ? _a : undefined; });
var PolaroidImage = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    height: auto;\n"], ["\n    width: 100%;\n    height: auto;\n"])));
var PolaroidContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-align: center;\n    padding: 10px 20px;\n"], ["\n    text-align: center;\n    padding: 10px 20px;\n"])));
var ImageLabeled = /** @class */ (function (_super) {
    __extends(ImageLabeled, _super);
    function ImageLabeled() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageLabeled.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Polaroid, { width: this.props.width, floated: this.props.floated, shadowed: this.props.shadowed },
                React.createElement(PolaroidImage, { src: this.props.url }),
                React.createElement(PolaroidContainer, null, this.props.content))));
    };
    return ImageLabeled;
}(React.PureComponent));
export default ImageLabeled;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ImageLabeled.js.map